import React from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import imgCancelapp from "../../../images/Cancelapp.png";
import imgNcheck from "../../../images/ncheck.svg";
import imgWarning from "../../../images/warning.png";
import "./helper.scss";
import moment from "moment";
import config from "../../config";
const MySwal = withReactContent(Swal);

export const getAlertPopUp = (custom) => {
  MySwal.fire({
    iconHtml: `<img src=${custom.error ? imgWarning : imgNcheck} />`,
    toast: true,
    position: "center",
    customClass: `custom-alert-popup ${custom.error ? " alert-error" : " alert-success"}`,
    showCancelButton: true,
    showConfirmButton: false,
    cancelButtonText: `<img src=${imgCancelapp} />`,
    cancelButtonColor: "#ffff",
    timer: 5000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
    ...custom,
  }).then((result) => { });
};

export const handleApiResonseErrors = (errors) => {
  if (errors) {
    for (var key in errors) {
      if (errors.hasOwnProperty(key)) {
        return errors[key][0];
      }
    }
  }
};


export const getFullMonthName = (shortMonth) => {
  const date = new Date(`${shortMonth} 1, 2020`);
  const options = { month: 'long' };
  return new Intl.DateTimeFormat('en-US', options).format(date);
}

export const dateFormat = 'MM/DD/YYYY';

export const dateFormatter = (date) => {
  return moment(date).format(dateFormat)
}

/** The codebase's stand-in for "no date of birth on file". */
export const NO_BIRTHDATE = "1970-01-01 00:00:00";

/**
 * Only these shapes are a date. Strict parsing against an explicit list is the
 * whole point: left to itself, moment falls back to `new Date()` for anything it
 * cannot match, and V8's legacy parser skips the "XX" tokens in a masked value
 * and keeps the year — turning "XX-XX-1985" into a confident, wrong 01/1/1985
 * that `isValid()` reports as good. JavaScriptCore rejects the same string, so
 * the unguarded version renders differently per browser.
 *
 * moment.ISO_8601 has to be here for Laravel timestamps; without it a strict
 * parse rejects "2026-09-09T12:34:56.000000Z".
 */
const BIRTHDATE_FORMATS = [
  moment.ISO_8601,
  "YYYY-MM-DD HH:mm:ss",
  "YYYY-MM-DD",
  "MM/DD/YYYY",
];

/**
 * A date of birth as it should be shown. The value arrives in one of three
 * shapes and only the last is a date:
 *
 *  - masked, "XX-XX-1985" — getMaskedNumber() withholds the day and month from
 *    everyone off the isv_channel and deliberately keeps the year. Shown
 *    verbatim: withholding the day and month is the point, so re-deriving them
 *    is the bug, and blanking it throws away the year the mask discloses.
 *  - the no-DOB sentinel, rendered as a dash like any other absent field.
 *  - a real `powerapps.field_birthdate` / `signers.date_of_birth` datetime.
 */
export const birthdateFormatter = (date, format = dateFormat) => {
  if (!date || date === NO_BIRTHDATE) return "-";

  const parsed = moment(date, BIRTHDATE_FORMATS, true);

  // Not a date at all. A mask carries the birth year and is worth showing;
  // anything else is unreadable and reads as absent.
  if (!parsed.isValid()) return /^X/i.test(date) ? date : "-";

  return parsed.format(format);
};

export const flattenValidationErrors = (errors) => {
  const result = {};

  for (const key in errors) {
    if (Array.isArray(errors[key]) && errors[key].length > 0) {
      result[key] = errors[key][0];
    }
  }
  return result;
}
export const maskNumber = (number) => {
  if (!number || typeof number !== 'string') {
    return '';
  }
  return number.slice(0, -4).replace(/\d/g, '*') + number.slice(-4);
};

export const formatPhoneNumber = (phone) => {
  const phoneNumber = ('' + phone).replace(/\D/g, '');
  if (!phoneNumber || typeof phoneNumber !== 'string' || phoneNumber.length !== 10) {
    return '';
  }
  const areaCode = phoneNumber.slice(0, 3);
  const centralOfficeCode = phoneNumber.slice(3, 6);
  const lineNumber = phoneNumber.slice(6);
  return `(${areaCode}) ${centralOfficeCode}-${lineNumber}`;
};

export const formatCurrency = (number) => {
  if (number === null || number === undefined || number === '') {
    return '0.00';
  }
  const num = typeof number === 'string' ? Number(number.replace(/[^0-9.-]+/g, '')) : Number(number);
  if (isNaN(num)) {
    return '';
  }
  return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const formatNumberWithSpaces = (number) => {
  if (!number || typeof number !== 'string') {
    number = number.toString();
  }
  return number.replace(/(\d{4})(?=\d)/g, '$1 ');
};

// esign helpers
export const getPdfUrl = (url, signerType) => {
  let pdfUrl;
  try {
    if (signerType) {
      pdfUrl = `${url}-${signerType}/signed`;
    } else {
      pdfUrl = `${url}/signed`;
    }
  } catch {
    pdfUrl = url;
  }
  return pdfUrl;
};

// Button styles
export const startButtonStyles = {
  position: "absolute",
  right: "6px",
  top: "0px",
  cursor: "pointer",
  background: "#4C70EF",
  border: "none",
  zIndex: 10,
  color: "#ffffff",
  fontSize: "14px",
  fontWeight: "500",
  padding: "0 12px",
  height: "24px",
  lineHeight: "0",
  borderRadius: "4px",
  boxShadow: "0px 6px 12px -2px rgba(48, 125, 246, 0.28)",
};

const startButtonAttributes = {
  id: "startButton",
  type: "button",
  innerText: "Start",
};

// arrow styles
export const arrowStyles = {
  position: "absolute",
  right: "72px",
  width: "14px",
  height: "14px",
  background: "#ffc233",
  transform: "rotate(45deg)",
  visibility: "hidden",
  zIndex: 99,
};

export const arrowAttributes = {
  className: "pdf-arrow",
};

// signature styles

const signatureButtonStyles = {
  position: "absolute",
  right: "23px",
  background: "#ffc233",
  border: "none",
  color: "black",
  fontSize: "14px",
  fontWeight: "500",
  padding: "0 12px",
  height: "20.8px",
  lineHeight: "0",
  borderRadius: "0 4px 4px 0",
  visibility: "hidden",
  zIndex: 99,
  width: 'fit-content',
};

const signatureButtonAttributes = {
  type: "button",
  innerText: "Sign",
  className: "pdf-button",
};

const signatureImgStyles = {
  position: "absolute",
  maxWidth: "200px",
  maxHeight: "25px",
  zIndex: 99,
};

export function setStyles(element, styles) {
  for (const property in styles) {
    element.style[property] = styles[property];
  }
  return element;
}

export function setAttributes(element, attributes) {
  for (const property in attributes) {
    element[property] = attributes[property];
  }
  return element;
}

export function createStartButton() {
  const button = document.createElement("button");
  setStyles(button, startButtonStyles);
  setAttributes(button, startButtonAttributes);
  return button;
}

export function createArrow() {
  const arrow = document.createElement("div");
  setStyles(arrow, arrowStyles);
  setAttributes(arrow, arrowAttributes);
  return arrow;
}

export function createSignatureButton() {
  const button = document.createElement("button");
  setStyles(button, signatureButtonStyles);
  setAttributes(button, signatureButtonAttributes);
  return button;
}

export function createLoadingIndicator() {
  const loading = document.createElement("div");
  loading.className = "loader";
  loading.innerText = "Loading...";
  loading.style.position = "absolute";
  loading.style.display = "none";

  return loading;
}

export function createSignatureImg() {
  const img = document.createElement("img");
  setStyles(img, signatureImgStyles);
  img.className = "sign-img";
  return img;
}

export function updateSignatureImgSize(img, x, y) {
  let maxWidth = "200px";
  let maxHeight = "25px";
  const updateImgSize = () => {
    if (window.innerWidth < 400) {
      img.style.top = `${y+2}px`;
      maxWidth = "80px";
      maxHeight = "8px";
    } else if (window.innerWidth < 500 && window.innerWidth > 400) {
      img.style.top = `${y+4}px`;
      maxWidth = "100px";
      maxHeight = "8px";
    } else if (window.innerWidth < 700 && window.innerWidth > 500) {
      img.style.top = `${y+4}px`;
      maxWidth = "110px";
      maxHeight = "12px";
    } else if (window.innerWidth < 800 && window.innerWidth > 700) {
      img.style.top = `${y+6}px`;
      maxWidth = "130px";
      maxHeight = "15px";
    } else if (window.innerWidth < 900 && window.innerHeight > 800) {
      maxWidth = "150px";
      maxHeight = "17px";
    } else {
      maxWidth = "200px";
      maxHeight = "25px";
    }  
    
    img.style.maxWidth = maxWidth;
    img.style.maxHeight = maxHeight;
  };

  updateImgSize();
  window.addEventListener("resize", updateImgSize);

  return {
    maxWidth,
    maxHeight,
  }
}

export function updateTimeStamp(timestamp, x, y) {
  const updateTimestampSize = () => {
    if (window.innerWidth < 400) {
      timestamp.style.fontSize = "4px";
      timestamp.style.top = `${y + 12}px`;
    } else if (window.innerWidth < 500 && window.innerWidth > 400) {
      timestamp.style.fontSize = "4px";
      timestamp.style.top = `${y + 13}px`;
    } else if (window.innerWidth < 700 && window.innerWidth > 500) {
      timestamp.style.fontSize = "6px";
      timestamp.style.top = `${y + 18}px`;
    } else if (window.innerWidth < 800 && window.innerWidth > 700) {
      timestamp.style.fontSize = "7px";
      timestamp.style.top = `${y + 25}px`;
    } else if (window.innerWidth < 900 && window.innerHeight > 800) {
      timestamp.style.fontSize = "8px";
      timestamp.style.top = `${y + 27}px`;
    } else {
      timestamp.style.top = `${y + 31}px`;
    }
  };

  updateTimestampSize();
  window.addEventListener("resize", updateTimestampSize);
}

export function updateButton(button, width) {
  const updateButtonStyle = () => {
    if (window.innerWidth < 500) {
      button.style.left = `${width - 2}px`;
    } else {
      button.style.left = `${width}px`;
    }
  };

  updateButtonStyle();
  window.addEventListener("resize", updateButtonStyle);
}

export function toggleDisplay(element1, element2, displayValue) {
  if (element1.style.display === "none") {
    element1.style.display = displayValue;
  }

  if (element2.style.display === "none") {
    element2.style.display = displayValue;
  }
}

export const formatNumberForChart = (num) => {
  if (num >= 1e12) {
    return (num / 1e12).toFixed(1).replace(/\.0$/, "") + "T"; // Trillions
  }
  if (num >= 1e9) {
    return (num / 1e9).toFixed(1).replace(/\.0$/, "") + "B"; // Billions
  }
  if (num >= 1e6) {
    return (num / 1e6).toFixed(1).replace(/\.0$/, "") + "M"; // Millions
  }
  if (num >= 1e3) {
    return (num / 1e3).toFixed(1).replace(/\.0$/, "") + "K"; // Thousands
  }
  return num.toString();
};
export const isEntitySuperAdmin = (user) => {
 if(
  (user?.organization_id == config.paymentcloud.PAYMENTCLOUD_ORG_ID  
  || user?.organization_id == config.paymentcloud.EMS_ORG_ID
  || user?.organization_id == config.paymentcloud.KURVPAY_ORG_ID) && user?.role === "admin"
 ){
  return true;
 }
 return false;
}

export const getPricingName = (qualifiedtype) => {
  if (qualifiedtype === "tiered") return "Tiered";
  if (qualifiedtype === "surcharge") return "Surcharge";
  if (qualifiedtype === "dual_pricing") return "Dual Pricing";
  if (qualifiedtype === "flat_rate") return "Flat Rate";
  if (qualifiedtype === "ic_plus") return "IC Plus";
  if (qualifiedtype === "kurv_pricing") return "Kurv Pricing";
};

export const getPricingDataById = (appData, id) => {
  let pricing = appData.prices.find((price) => price.id === id);
  return pricing ? pricing.pivot : { dollars: 0, percent: 0 };
};

export const isMultipleLocations = (value) =>
  String(value ?? "").toLowerCase() === "yes";

export const formatLocationPair = (current, total) =>
  `${current ?? "-"} of ${total ?? "-"}`;

// Returns the "Multi-Merchant" / "Additional Location" {label, value} rows
// for list-style renderers (e.g. MerchantDetails/BusinessProfile.jsx), or
// [] when the source isn't flagged as multiple locations.
export const getMultiLocationItems = (source) => {
  if (!isMultipleLocations(source?.is_multiple_locations)) return [];

  return [
    {
      label: "Multi-Merchant",
      value: formatLocationPair(source?.multi_merchant, source?.multi_merchant_of),
    },
    {
      label: "Additional Location",
      value: formatLocationPair(source?.additional_location, source?.additional_location_of),
    },
  ];
};
